import { getFormFields } from '../../services/entities/errorService'

export const errorModule = {
  namespaced: true,
  state: {
    formFieldsErrors: getFormFields(),
    userMessage: {
      isActive: false,
      popupType: '',
      popupTypeProps: {},
      popupAlignmentClass: 'justify-center'
    }
  },
  mutations: {
    setKeyValue (state, payload) {
      let { prop, value } = payload
      state = { ...state, [prop]: value }
    },
    updateFormFieldErrors (state, { fieldsShallowCopy }) {
      state.formFieldsErrors = {
        ...state.formFieldsErrors,
        ...fieldsShallowCopy
      }
    },
    updateUserMessage (state, payload) {
      state.userMessage = { ...state.userMessage, ...payload }
    }
  },
  actions: {
    // Will reset the entire fields values.
    clearAllFormErrors ({ commit }) {
      let cleanFields = getFormFields()
      commit('setKeyValue', { prop: 'formFieldsErrors', value: cleanFields })
    },
    // Takes array of fields, map trough and reset thier value .
    clearSpecificFieldError ({ commit, state }, fields) {
      let fieldsShallowCopy = { ...state.formFieldsErrors }
      fields.forEach(field => {
        fieldsShallowCopy[field] = ''
      })
      commit('updateFormFieldErrors', { fieldsShallowCopy })
    },
    setFieldContent ({ commit, state }, payload) {
      // Payload is object Ex. {field: '', content: ''}
      const { field, content } = payload
      let fieldsShallowCopy = { ...state.formFieldsErrors }
      fieldsShallowCopy[field] = content
      commit('updateFormFieldErrors', { fieldsShallowCopy })
    }
  },
  getters: {
    fieldErrors ({ formFieldsErrors }) {
      // Return shallow copy, to avoid mutation out of module scope
      return { ...formFieldsErrors }
    },
    getUserMessage ({ userMessage }) {
      return { ...userMessage }
    }
  }
}



// WEBPACK FOOTER //
// ./src/RF_store/modules/errors.module.js